import { Dispatch, SetStateAction, useState } from 'react';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { queryClient } from 'providers/queryClient';
import { useNotify, useRecordContext, useUpdate } from 'react-admin';
import { Mapping } from 'types/embedded/gatewayRule';

type UseMappingDescriptionReturnValue = {
  showDescription: boolean;
  editDescription: boolean;
  setShowDescription: Dispatch<SetStateAction<boolean>>;
  setEditDescription: Dispatch<SetStateAction<boolean>>;
  handleSubmitDescription: (value: string) => void;
};

export const useMappingDescription = (): UseMappingDescriptionReturnValue => {
  const translate = useTypedTranslate();
  const notify = useNotify();
  const [update] = useUpdate();

  const mappingRecord = useRecordContext<Mapping>();

  const [showDescription, setShowDescription] = useState(false);
  const [editDescription, setEditDescription] = useState(false);

  const handleSubmitDescription = (value: string) => {
    update(
      'mappings',
      { id: mappingRecord?.['@id'], data: { description: value } },
      {
        onSuccess: () => {
          notify(translate('app.common.updated'), { type: 'success' });
          queryClient.invalidateQueries({ queryKey: ['gateway_rules'] });
        },
      },
    );
  };

  return {
    showDescription,
    editDescription,
    setShowDescription,
    setEditDescription,
    handleSubmitDescription,
  };
};
